<!--Package used: https://github.com/Akryum/floating-vue -->
<script setup lang="ts">
type ToolTipTrigger = 'hover' | 'click' | 'focus' | 'touch'
interface Props {
  placement?:
    | 'auto'
    | 'auto-start'
    | 'auto-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end'
  delay?: number //in ms
  shown?: boolean
  distance?: number
  skidding?: number
  arrowPadding?: number
  autoHide?: boolean //When click outside
  disabled?: boolean
  hideArrow?: boolean
  triggers?: ToolTipTrigger[]
  flip?: boolean
  theme?: string
  container?: string
}

const props = withDefaults(defineProps<Props>(), {
  placement: 'auto',
  delay: 0,
  shown: false,
  distance: 14,
  skidding: 0,
  arrowPadding: 0,
  autoHide: true,
  disabled: false,
  hideArrow: false,
  flip: true,
  triggers: () => ['click'],
  theme: 'dropdown',
  container: 'body',
})

const computedArrowPadding = computed(() => {
  if (props.hideArrow) return 200000
  return props.arrowPadding
})

const emit = defineEmits(['onClose'])

const onClose = () => {
  emit('onClose')
}
</script>
<template>
  <div>
    <VDropdown
      aria-id="dropdown"
      :flip="flip"
      :triggers="triggers"
      :placement="placement"
      :container="container"
      :delay="delay"
      :shown="shown"
      :distance="distance"
      :skidding="skidding"
      :arrow-padding="computedArrowPadding"
      :auto-hide="autoHide"
      :disabled="disabled"
      :theme="theme"
      @auto-hide="onClose"
    >
      <!-- This will be the popover reference (for the events and position) *Has to be HTML Button tag* -->
      <slot name="button" />

      <!-- This will be the content of the popover -->
      <template #popper>
        <slot name="content" />
      </template>
    </VDropdown>
  </div>
</template>

<style>
.v-popper--theme-dropdown .v-popper__inner {
  @apply rounded-lg
  border 
  border-brand-gray-200;
}
</style>
